export default __webpack_public_path__ + "static/media/137ssasset_2.efe8822a.png";